export const MessageRole = {
    USER: "user",
    BOT: "bot",
};

export const MessageStatus = {
    SENT: "sent",
    ERROR: "error",
};

export const createMessage = ({ role, text, status = MessageStatus.SENT }) => ({
    id: crypto.randomUUID(),
    role,
    text,
    status,
    timestamp: Date.now(),
});
